import { useEffect, useRef } from 'react';
import type { GeneralFunction } from '@asherng/common-types';
import type { UseEventListener } from './types';

const useEventListener: UseEventListener = (eventName, handler, element = window): void => {
  const savedHandler = useRef<GeneralFunction>();

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const isSupported = element && element.addEventListener;

    if (!isSupported) {
      return;
    }

    const eventListener = (event: Event) => savedHandler?.current?.(event);

    element.addEventListener(eventName, eventListener);

    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
};

export default useEventListener;
